import { render } from "./ProductInfo.vue?vue&type=template&id=82a8d51a&scoped=true&ts=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"

import "./ProductInfo.vue?vue&type=style&index=0&id=82a8d51a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a8d51a"]])

export default __exports__